import { z } from 'zod';
import { modelStatusSchema, videoStatusSchema } from '../enums.js';
/**
 * Projet **transverse** (ADR-0024, incrément 2) : une collection cloisonnée qui regroupe des objets
 * hétérogènes, indépendamment de l'arbre Campagne → Session. Vidéos (2a), puis images et modèles
 * (2c). Ne pas confondre avec `Campaign` (l'ancien `Project`).
 */
export const createProjectSchema = z.object({
    name: z.string().trim().min(2).max(150),
    description: z.string().trim().max(2000).optional(),
});
export const updateProjectSchema = createProjectSchema.partial();
/** Un projet et ses compteurs par type d'objet (vue liste, ex. Overview). */
export const projectSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    videoCount: z.number().int().nonnegative(),
    imageCount: z.number().int().nonnegative(),
    modelCount: z.number().int().nonnegative(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
/** Une vidéo membre d'un projet (référence compacte, pour le détail). */
export const projectVideoSchema = z.object({
    videoId: z.string(),
    title: z.string(),
    status: videoStatusSchema,
    addedAt: z.coerce.date(),
});
/**
 * Une image membre d'un projet (référence compacte). On porte le titre de la vidéo source pour
 * l'affichage et le lien : le détail reste léger, comme la liste des vidéos (pas d'URL signée ici).
 */
export const projectImageSchema = z.object({
    imageId: z.string(),
    videoId: z.string(),
    videoTitle: z.string(),
    addedAt: z.coerce.date(),
});
/** Un modèle membre d'un projet (référence compacte, pour le détail). */
export const projectModelSchema = z.object({
    modelId: z.string(),
    name: z.string(),
    version: z.string(),
    status: modelStatusSchema,
    addedAt: z.coerce.date(),
});
/** Détail d'un projet : ses champs + ses objets membres (vidéos, images, modèles). */
export const projectDetailSchema = projectSchema.extend({
    videos: z.array(projectVideoSchema),
    images: z.array(projectImageSchema),
    models: z.array(projectModelSchema),
});
/** Corps d'ajout d'une vidéo à un projet. Seul l'id voyage ; le serveur revalide l'appartenance. */
export const addProjectVideoSchema = z.object({
    videoId: z.string().cuid2(),
});
/** Corps d'ajout d'une image à un projet. */
export const addProjectImageSchema = z.object({
    imageId: z.string().cuid2(),
});
/** Corps d'ajout d'un modèle à un projet. */
export const addProjectModelSchema = z.object({
    modelId: z.string().cuid2(),
});
//# sourceMappingURL=project.js.map